import { twMerge } from 'tailwind-merge';

import { SectionContent, type SectionContentProps } from '../SectionContent';

export type ContentProps = SectionContentProps;

export function Content({ className, ...props }: ContentProps) {
  return (
    <SectionContent
      className={twMerge('pt-20 pb-0 text-sm', className)}
      {...props}
    />
  );
}
